const { InspectorControls } = wp.blockEditor;
const { TextControl, PanelBody, SelectControl, ToggleControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { is_directv } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <TextControl
          label="Título do Plano"
          value={attributes.plans_title}
          onChange={(value) => setAttributes({ plans_title: value })}
        />
        <TextControl
          label="Descrição do Plano"
          value={attributes.plans_desc}
          onChange={(value) => setAttributes({ plans_desc: value })}
        />
        <ToggleControl
          label={'Ativar planos DirecTV GO?'}
          checked={is_directv}
          onChange={() => setAttributes({ is_directv: !is_directv })}
        />
        <SelectControl
          label="Tipo"
          value={attributes.plans_type}
          options={[
            { label: 'PF', value: 'PF' },
            { label: 'PJ_PME', value: 'PJ_PME' },
          ]}
          onChange={(value) => setAttributes({ plans_type: value })}
        />
        <TextControl
          label="Código Cidade"
          value={attributes.plans_city_code}
          onChange={(value) => setAttributes({ plans_city_code: value })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
